import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload, getSuccessPayload } from 'modules/utils';

import * as actionTypes from './actionTypes';

export const fetchRefDataRequest = createAction(actionTypes.FETCH_REFDATA_REQUEST, (meta = {}) => ({
  payload: {
    request: {
      method: 'GET',
      url: '/refdata/config/FO',
    },
  },
  meta: {
    '@app-request': true,
    ...meta
  },
}));

export const fetchRefDataSuccess = createAction(actionTypes.FETCH_REFDATA_SUCCESS, getSuccessPayload);
export const fetchRefDataFailure = createAction(actionTypes.FETCH_REFDATA_FAILURE, getFailurePayload);
